const initialState = {
    info: {},
    chat: [],
    inputText: '',

    attachFile: false,
    filePreview: null,
    isRecording: false, 
    audioBlob: null,
    recordState: 'idle', // idle | recording | locked
    recordTime: 0,
    isMicPressed: false,
};
const historyChat = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_HISTORY_CHAT':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default historyChat;
